import { useTheme } from "@hooks/useTheme";

const ToggleSwitch = ({ 
  checked, 
  onChange, 
  size = "md",
  disabled = false,
  className = "",
  ...props 
}) => {
  const { colors } = useTheme();

  // Size configurations
  const sizeConfigs = {
    sm: {
      track: "w-8 h-4",
      thumb: "after:left-[0.125rem] after:h-3 after:w-3 peer-checked:after:translate-x-4"
    },
    md: {
      track: "w-[3rem] h-[1.40625rem]",
      thumb: "after:left-[0.15625rem] after:h-[1.09375rem] after:w-[1.09375rem] peer-checked:after:translate-x-[1.59375rem]"
    },
    lg: {
      track: "w-14 h-6",
      thumb: "after:left-[0.125rem] after:h-5 after:w-5 peer-checked:after:translate-x-8"
    }
  };

  const currentSize = sizeConfigs[size] || sizeConfigs.md;

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label
      className={`
        relative inline-flex cursor-pointer hover:cursor-pointer items-center justify-start
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
      {...props}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="sr-only peer"
      />
      <div
        className={`
          ${currentSize.track}
          peer-focus:outline-none rounded-full peer 
          ${colors.controlThumb}
          after:-translate-y-1/2 after:top-1/2 after:content-[''] 
          after:absolute after:rounded-full
          after:transition-all after:shadow-sm border 
          ${currentSize.thumb}
          ${checked ? colors.borderPrimary : "border-none"} 
          ${checked ? colors.bgActiveToggle : colors.bgInput}
        `}
      />
    </label>
  );
};

export default ToggleSwitch; 